var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecentIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0884 0.5C8.14619 0.5 0.0883789 8.55781 0.0883789 18.5V35.375C0.0883789 35.9984 0.589941 36.5 1.21338 36.5H9.83838C11.4931 36.5 12.8384 35.1547 12.8384 33.5V23.75C12.8384 22.0953 11.4931 20.75 9.83838 20.75H3.46338V18.5C3.46338 10.4234 10.0118 3.875 18.0884 3.875C26.1649 3.875 32.7134 10.4234 32.7134 18.5V20.75H26.3384C24.6837 20.75 23.3384 22.0953 23.3384 23.75V33.5C23.3384 35.1547 24.6837 36.5 26.3384 36.5H34.9634C35.5868 36.5 36.0884 35.9984 36.0884 35.375V18.5C36.0884 8.55781 28.0306 0.5 18.0884 0.5ZM9.46338 24.125V33.125H3.46338V24.125H9.46338ZM32.7134 33.125H26.7134V24.125H32.7134V33.125Z",
    fill: "#FE4A23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentIcon04);
export default __webpack_public_path__ + "static/media/recent-icon-04.e146239783e1c35171605e9919a73cb4.svg";
export { ForwardRef as ReactComponent };